export default __webpack_public_path__ + "static/media/profile-contact-info-icon.884e2962.svg";